import Image from 'next/image';
import React from 'react';

interface BedIconProps {
  size?: number;
  className?: string;
}

const BedIcon: React.FC<BedIconProps> = ({ size = 24, className = '' }) => {
  return (
    <Image
      src="/images/icons/property-icon-bed.svg"
      alt="Bed icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default BedIcon;
